import { graphicalEvent } from "../endpointUrl";
import { ENV } from "../env";
import { request } from "../utils";
import { AdType } from "@digital-media/ad-model";

export async function sendGraphicalAdEvent(
  eventUrl: string,
  adType = AdType.HTML
) {
  if (adType === AdType.JSON) {
    await request(`${ENV.DMAS}/${graphicalEvent}`, {
      headers: { location: eventUrl },
    });
  } else {
    await request(eventUrl, { mode: "no-cors" });
  }
}
